module.exports = __webpack_public_path__ + "img/ribeye.8112577e.png";